module.exports = __webpack_public_path__ + "static/media/qui-sommes-nous.26687d13.jpg";